import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { capabilitiesForPath, homePathFor } from '@/hooks/useWorkspace'

const roleLabel = (role) => role.replaceAll('_', ' ')

/**
 * Capability wave (3 Oct 2026, R-03) · What a member sees on a screen their roles do not let
 * them view — instead of the screen's own empty state, which said things that were not true
 * ("No feeds registered", "No rules yet") to people who simply could not read them, with the
 * API's refusal toasted over it. Says what the screen needs, what the member holds, and who
 * can change it.
 */
const NoAccess = ({ path }) => {
  const context = useSelector((state) => state.organisationContext)
  const capabilities = context?.capabilities || {}
  const needs = capabilitiesForPath(path) || []
  const labels = needs.map((key) => `"${capabilities?.[key]?.label || key}"`)
  const home = homePathFor(context?.roles || [], capabilities)
  const roles = (context?.roles || []).map(roleLabel)

  return (
    <div className="flex min-h-[60vh] items-center justify-center px-4" data-testid="no-access">
      <div className="w-full max-w-lg rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm">
        <h1 className="mb-2 text-lg font-semibold text-slate-900">You don&apos;t have access to this page</h1>
        <p className="mb-2 text-sm leading-relaxed text-gray-600">
          {labels.length
            ? <>It needs {labels.length > 1 ? 'one of ' : ''}{labels.join(', ')}, which your roles don&apos;t include.</>
            : <>Your roles don&apos;t include what this page needs.</>}
        </p>
        <p className="mb-6 text-sm leading-relaxed text-gray-600">
          {roles.length ? <>Your roles: <span className="capitalize">{roles.join(', ')}</span>. </> : null}
          An organisation administrator can change your roles.
        </p>
        <Link to={home} className="rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:opacity-90">
          Go to your home page
        </Link>
      </div>
    </div>
  )
}

export default NoAccess
